import React, { useContext } from 'react';
import moment from 'moment';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { API_DATE_FORMAT, API_DATE_TIME_FORMAT } from '@ubeya/shared/constants';
import { RequestTypes } from '@ubeya/shared/hooks/generic/useRequestsTypes';

const WhenRenderer = ({ rowData: { typeId, data }, columnData: { mappedRequestsTypesBySlug = {} } }) => {
  const { dateFormat } = useContext(ConfigContext);

  if (typeId === RequestTypes.LEAVE_REQUEST) {
    const { startDate, endDate } = data || {};
    const startMoment = moment(startDate, API_DATE_FORMAT);
    const endMoment = moment(endDate, API_DATE_FORMAT);
    const sameDay = startMoment.isSame(endMoment, 'day');

    if (sameDay) {
      return startMoment.isValid() ? startMoment.format(dateFormat) : <></>;
    }

    return (
      <>
        {[startMoment, endMoment]
          .filter((current) => current.isValid())
          .map((time) => time.format(dateFormat))
          .join(' - ')}
      </>
    );
  }

  if (
    typeId === mappedRequestsTypesBySlug?.absence?.id ||
    typeId === mappedRequestsTypesBySlug?.['release-shift']?.id
  ) {
    const { startTime, endTime } = data;
    const startTimeMoment = moment(startTime, API_DATE_TIME_FORMAT);
    const endTimeMoment = moment(endTime, API_DATE_TIME_FORMAT);
    const sameDay = startTimeMoment.diff(endTimeMoment, 'day') === 0;

    if (sameDay) {
      return startTimeMoment.format(dateFormat);
    }

    return (
      <>
        {[startTimeMoment, endTimeMoment]
          .filter((current) => moment(current).isValid())
          .map((time) => time.format(dateFormat))
          .join(' - ')}
      </>
    );
  }

  return <></>;
};

export default WhenRenderer;
